import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFilePowerpoint } from '@fortawesome/free-solid-svg-icons';
import { useLanguage } from '../../../contexts/LanguageContext';
import './PowerPointViewer.css';

const PowerPointViewer = ({ isOpen, onClose, fileUrl }) => {
  const { t } = useLanguage();

  if (!isOpen || !fileUrl) return null;

  // Check if URL is local, because Office Online Viewer requires a public accessible URL
  const isLocalUrl = fileUrl.includes('localhost') || fileUrl.includes('127.0.0.1');

  // Office Online Viewer Embed URL
  const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;

  return (
    <AnimatePresence>
      <motion.div
        className="pptx-viewer-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="pptx-viewer-modal"
          initial={{ scale: 0.9, y: 20, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          exit={{ scale: 0.9, y: 20, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="pptx-viewer-header">
            <div className="header-title">
              <FontAwesomeIcon icon={faFilePowerpoint} className="pptx-icon" />
              <h3>عرض العرض التقديمي (PowerPoint)</h3>
            </div>
            <button className="close-btn" onClick={onClose} title={t('close') || "إغلاق"}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className="pptx-viewer-body">
            {isLocalUrl ? (
              <div className="local-url-warning">
                <h4>عذراً، لا يمكن عرض الملفات المحلية</h4>
                <p>
                  يستخدم هذا العارض خدمة Microsoft Office Online، والتي تتطلب أن يكون رابط الملف متاحاً على الإنترنت بشكل عام. 
                  نظراً لأن الرابط الحالي محلي (localhost)، يرجى تنزيل الملف بدلاً من ذلك وعرضه على جهازك.
                </p>
                <a href={fileUrl} download className="download-btn-fallback">
                  تنزيل الملف
                </a>
              </div>
            ) : (
              <iframe
                src={officeViewerUrl}
                width="100%"
                height="100%"
                frameBorder="0"
                title="PowerPoint Viewer"
              >
                جهازك لا يدعم الإطارات (Iframes). يرجى تنزيل الملف.
              </iframe>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default PowerPointViewer;
